import Home from 'pages/index';
import Guide from 'pages/guide';
import Test from 'pages/test';

export interface RouteMetaTs {
  layout?: string | undefined;
}

export interface RouteTs {
  path: string;
  component: React.FunctionComponent;
  name: string;
  meta?: RouteMetaTs | undefined;
};

export default [
  {
    path: "/",
    component: Home,
    name: 'home',
    meta: {
      layout: 'index',
    },
  },
  {
    path: "/home",
    component: Home,
    name: 'home',
  },
  {
    path: "/guide",
    component: Guide,
    name: 'guide',
  },
  {
    path: "/test",
    component: Test,
    name: 'test',
  },
  {
    path: "/exchange",
    component: Test,
    name: 'test',
  },
  {
    path: "/c2c",
    component: Test,
    name: 'test',
  },
  {
    path: "/support",
    component: Test,
    name: 'test',
  },
];



// WEBPACK FOOTER //
// ./src/config/routes.ts